import { ref } from 'vue';

// Section actuellement ouverte dans la navigation
export const openSection = ref<string | null>(null);
export const activeSection = ref<string | null>(null);
export const activeSubSection = ref<string | null>(null);

export function toggleSection(sectionId: string) {
  if (openSection.value === sectionId) {
    openSection.value = null;
  } else {
    openSection.value = sectionId;
  }
}

export function setOpenSection(sectionId: string) {
  openSection.value = sectionId;
}

export function setActiveSection(sectionId: string | null) {
  activeSection.value = sectionId;
}

export function setActiveSubSection(sectionId: string | null) {
  activeSubSection.value = sectionId;
}

